// extracted by mini-css-extract-plugin
export default {"message":"GqJJe4ABcPXDb6NT5_jl"};